import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';

const Sidebar = ({ items }) => {
  const location = useLocation();
  
  return (
    <aside>
      <div className="side_menu">
        <ul>
          {items.map(item => (
            <li key={item.to} className={location.pathname === item.to ? 'on' : ''}>
              <NavLink to={item.to}>
                <div>
                  <p>{item.label}</p>
                </div>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
      <div className="logout" onClick={() => {/* TODO: logout */}}>
        <i>❯</i>
        <p>로그아웃</p>
      </div>
    </aside>
  );
};

export default Sidebar;
